import React, { Component } from 'react';
import AsyncSelect from 'react-select/async';
import { toast } from 'react-toastify';
import ClipLoader from 'react-spinners/ClipLoader';
import debounce from 'lodash/debounce';
import { Container, Card, Button, ButtonGroup, Badge } from 'react-bootstrap';
import {
  FaHashtag,
  FaIdCard,
  FaUserCircle,
  FaUserCheck,
  FaCheckCircle,
  FaSearch,
} from 'react-icons/fa';
import HeaderAzul from '~/Components/HeaderAzul/HeaderAzul';
import * as api from '~/Services/Service';

const TIPOS_BUSCA = [
  { codigo: 1, label: 'Senha', icon: FaHashtag },
  { codigo: 2, label: 'Código', icon: FaIdCard },
  { codigo: 3, label: 'CPF', icon: FaUserCircle },
];

var getNivelLabel = (atendimentoPreferencial) => {
  if (atendimentoPreferencial === true) return { texto: 'Diamante', cor: '#1565C0', bg: '#E3F2FD' };
  if (atendimentoPreferencial === false) return { texto: 'Topázio', cor: '#E65100', bg: '#FFF3E0' };
  return { texto: 'Sem nível', cor: '#616161', bg: '#F5F5F5' };
};

var formatOptionLabel = (option) => {
  var nivel = getNivelLabel(option.atendimentoPreferencial);
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <span>{option.label}</span>
      <span style={{
        backgroundColor: nivel.bg,
        color: nivel.cor,
        padding: '2px 8px',
        borderRadius: '4px',
        fontSize: '0.75rem',
        fontWeight: 700,
        marginLeft: '8px',
      }}>
        {nivel.texto}
      </span>
    </div>
  );
};

export default class LancamentoBaixarSenhaComprador extends Component {
  state = {
    tipoBusca: 1,
    cliente: null,
    codigoAtendimento: '',
    isSubmitting: false,
  };

  alteraTipo = tipoBusca => {
    this.buscaClienteDebounced.cancel();
    this.setState({ tipoBusca, cliente: null, codigoAtendimento: '' });
  };

  buscaClienteDebounced = debounce((tipoBusca, value, callback) => {
    api.getProspectoAtendimentoTodos(tipoBusca, value).then(
      data => {
        var options = [];
        if (Array.isArray(data)) {
          options = data.map(item => ({
            value: item.codigo,
            label: item.prospecto.nome,
            data: item,
            atendimentoPreferencial: item.atendimento_preferencial,
          }));
        } else if (data) {
          options.push({
            value: data.codigo,
            label: data.prospecto.nome,
            data,
            atendimentoPreferencial: data.atendimento_preferencial,
          });
        }
        callback(options);
      },
      error => {
        callback([]);
      }
    );
  }, 350);

  buscaCliente = (value, callback) => {
    if (!value) {
      this.buscaClienteDebounced.cancel();
      callback([]);
      return;
    }
    this.buscaClienteDebounced(this.state.tipoBusca, value, callback);
  };

  handleSelectCliente = option => {
    this.setState({ cliente: option.data, codigoAtendimento: option.value });
  };

  concluirAtendimento = async () => {
    const { cliente } = this.state;
    if (!cliente) return;
    this.setState({ isSubmitting: true });
    try {
      await api.finalizarFluxoAtendimentoLancamento(cliente.codigo, 1);
      toast.success('Senha baixada/finalizada com sucesso!');
      this.setState({ cliente: null, codigoAtendimento: '' });
    } catch (error) {
      toast.error(error.message);
    } finally {
      this.setState({
        cliente: null,
        codigoAtendimento: '',
        tipoBusca: 1,
        isSubmitting: false,
      });
    }
  };

  getSelectedOption = () => {
    const { cliente, codigoAtendimento } = this.state;
    if (cliente && cliente.codigo === codigoAtendimento) {
      return {
        value: cliente.codigo,
        label: cliente.prospecto.nome,
        data: cliente,
        atendimentoPreferencial: cliente.atendimento_preferencial,
      };
    }
    return null;
  };

  render() {
    const { tipoBusca, cliente, isSubmitting } = this.state;
    const tipoAtual = TIPOS_BUSCA.find(t => Number(t.codigo) === Number(tipoBusca)) || TIPOS_BUSCA[0];
    const nivel = cliente ? getNivelLabel(cliente.atendimento_preferencial) : null;

    return (
      <>
        <Container className="py-3 py-md-4" style={{ maxWidth: '720px' }}>
        <HeaderAzul title="Baixar Senha do Comprador" contemPesquisa={false} />
          <Card className="border-0 shadow-sm rounded-lg">
            <Card.Body className="p-3 p-md-4 p-lg-5">
              <div className="text-center mb-4">
                <h4 className="font-weight-bold mb-1">Finalizar Atendimento</h4>
                <p className="text-muted small mb-0">
                  Busque o cliente que finalizou a compra e dê baixa na senha.
                </p>
              </div>

              <label className="text-muted small font-weight-bold text-uppercase mb-2 d-block">
                Buscar por
              </label>
              <ButtonGroup className="d-flex mb-3 flex-wrap" style={{ gap: '6px' }}>
                {TIPOS_BUSCA.map(({ codigo, label, icon: Icon }) => {
                  const ativo = Number(codigo) === Number(tipoBusca);
                  return (
                    <Button
                      key={codigo}
                      variant={ativo ? 'primary' : 'outline-primary'}
                      onClick={() => this.alteraTipo(codigo)}
                      disabled={isSubmitting}
                      aria-label={`Buscar por ${label}`}
                      className="d-flex align-items-center justify-content-center flex-grow-1 py-2"
                      style={{ minWidth: '90px', borderRadius: '8px' }}
                    >
                      <Icon className="mr-2" /> {label}
                    </Button>
                  );
                })}
              </ButtonGroup>

              <AsyncSelect
                placeholder={`Informe ${tipoAtual.label.toLowerCase()} do cliente`}
                noOptionsMessage={() => 'Nenhum cliente encontrado'}
                loadOptions={this.buscaCliente}
                onChange={this.handleSelectCliente}
                value={this.getSelectedOption()}
                isDisabled={isSubmitting}
                formatOptionLabel={formatOptionLabel}
                styles={{
                  control: base => ({
                    ...base,
                    minHeight: '46px',
                    borderRadius: '8px',
                    fontSize: '1rem',
                  }),
                }}
              />

              {!cliente && (
                <div className="text-center text-muted py-4">
                  <FaSearch size={28} className="mb-2" style={{ opacity: 0.4 }} />
                  <div className="small">
                    Busque um cliente para concluir o atendimento.
                  </div>
                </div>
              )}

              {cliente && (
                <>
                  <div
                    className="mt-4 p-3 rounded d-flex align-items-center"
                    style={{ background: '#f1f5fb' }}
                  >
                    <FaUserCheck size={28} className="text-primary mr-3" />
                    <div className="flex-grow-1">
                      <div className="font-weight-bold">{cliente.prospecto.nome}</div>
                      {nivel && (
                        <Badge
                          style={{
                            background: nivel.bg,
                            color: nivel.cor,
                            fontWeight: 700,
                          }}
                        >
                          {nivel.texto}
                        </Badge>
                      )}
                    </div>
                  </div>

                  <Button
                    variant="success"
                    size="lg"
                    block
                    className="mt-4 d-flex align-items-center justify-content-center font-weight-bold"
                    onClick={this.concluirAtendimento}
                    disabled={isSubmitting}
                    style={{ borderRadius: '8px' }}
                  >
                    {isSubmitting ? (
                      <ClipLoader size={20} color={'#fff'} />
                    ) : (
                      <FaCheckCircle className="mr-2" />
                    )}
                    <span className="ml-2">
                      {isSubmitting ? 'Concluindo...' : 'Concluir Atendimento'}
                    </span>
                  </Button>
                </>
              )}
            </Card.Body>
          </Card>
        </Container>
      </>
    );
  }
}
